// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zmcmrivswbszhqqragli.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InptY21yaXZzd2JzemhxcXJhZ2xpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjQ3NjI2MjMsImV4cCI6MjA0MDMzODYyM30.de6N3ohM3QX26joh5x8SDXTRjAc-qJgkS6tqH-OU9LA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);